








































































































































































import Vue from "vue";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";

import DeviceTree from "@/components/DeviceTree/index.vue";
import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import {
    GetConfigurationVersionAndSectionsCommand,
    GetConfigurationVersionAndSectionsReqData,
} from "@/model/communication/caosConfiguration/GetConfigurationVersionAndSectionsCommand";
import { GetConfigurationVersionAndSectionsResData } from "@/model/communication/caosConfiguration/GetConfigurationVersionAndSectionsResData";
import { AddTemplateCommand, AddTemplateReqData } from "@/model/communication/caosConfiguration/AddTemplateCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { CaosConfigurationTemplateContentsEnum, caosConfigurationTemplateContentToString } from "@/model/data/enums/CaosConfigurationTemplateContentsEnum";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export default Vue.extend({
    props: { showDialog: Boolean },
    components: {
        DeviceTree,
    },
    data() {
        return {
            moment,
            MODULE_COLORS,
            newTemplate: null,
            templateInstallations: [],
            reload: 0,
            step: 1,
            selectedContent: [],
            availableConfigSections: [],
            loadingGetConfigVersion: false,
            loadingAddTemplate: false,
            endingMessage: "",
            error: false,
            errorMessage: "",
            templateBaseConfiguration: null,
            CaosConfigurationTemplateContentsEnum,
        };
    },
    computed: {
        showAddTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
                this.step = 1;
                this.templateInstallations = [];
                this.reset();
                this.reload += 1;
            },
        },
        canContinue() {
            if (this.step == 2) {
                if (!this.selectedContent || this.selectedContent.length < 1 || this.templateContentRequiresValid != "" || !this.newTemplate.name) return false;
            }
            return this.templateInstallations && this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length == 1 && !this.error;
        },
        alertColor() {
            if (this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length == 1) return "success";
            return "error";
        },
        alertText() {
            let filteredtemplateInstallations = this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device);
            if (filteredtemplateInstallations.length > 1) return this.$t("downloadLogs.selectOnlyOneInstallation");
            if (filteredtemplateInstallations.length == 0) return this.$t("caosTemplate.selectAtLeastOneInstallation");
            return this.$t("caosTemplate.installationSelected", { installation: filteredtemplateInstallations[0].name });
        },
        selectAllIcon() {
            return this.selectedContent.length == this.availableConfigSections.length ? "fa-check-square" : "far fa-square";
        },
        templateContentRequiresValid() {
            if (this.selectedContent && this.selectedContent.length > 0) {
                for (let content of this.selectedContent) {
                    let section: string = CaosConfigurationTemplateContentsEnum[content];
                    let requirements: string[] = this.templateBaseConfiguration[section].requires;
                    if (requirements && requirements.length > 0) {
                        for (let requirement of requirements) {
                            if (!this.selectedContent.includes(CaosConfigurationTemplateContentsEnum[requirement])) {
                                let sectioni18n = this.$t(caosConfigurationTemplateContentToString(content));
                                let requirement18n = this.$t(caosConfigurationTemplateContentToString(CaosConfigurationTemplateContentsEnum[requirement]));
                                return this.$t("caosTemplate.contentRequirement", { section: sectioni18n, requirement: requirement18n });
                            }
                        }
                    }
                }
            }
            return "";
        },
    },
    methods: {
        reset() {
            this.error = false;
            this.errorMessage = "";
            this.selectedContent = [];
            this.availableConfigSections = [];
            this.newTemplate = null;
        },

        continueStep() {
            if (this.step == 1) {
                this.newTemplate = new CaosConfigurationTemplate();
                this.newTemplate.sourceInstallationName = this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device)[0].name;
                this.sendRequestGetConfigurationVersion();
            } else if (this.step == 2) {
                let templateContent = CaosConfigurationTemplateContentsEnum.none;
                this.selectedContent.forEach((content) => {
                    templateContent |= content;
                });
                this.newTemplate.templateContent = templateContent;
                this.sendRequestCreateTemplate();
            } else if (this.step == 3) {
                this.showAddTemplateDialog = false;
                return;
            }
            this.step += 1;
        },
        backStep() {
            if (this.step == 2) {
                this.reset();
            }
            this.step -= 1;
        },

        async sendRequestGetConfigurationVersion() {
            this.loadingGetConfigVersion = true;
            let reqData = new GetConfigurationVersionAndSectionsReqData(this.newTemplate.sourceInstallationName);
            let response: GetConfigurationVersionAndSectionsResData = await new GetConfigurationVersionAndSectionsCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                this.newTemplate.caosVersion = response.caosConfiguration.caosVersion;
                this.templateBaseConfiguration = response.caosConfiguration;
                Object.keys(response.caosConfiguration).forEach((key) => {
                    if (key != "caosVersion" && !response.caosConfiguration[key]["binding"]) {
                        this.availableConfigSections.push({
                            name: key,
                            namei18n: this.$t(`enum.caosConfigurationTemplateContents.${key}`),
                            contentValue: CaosConfigurationTemplateContentsEnum[key],
                        });
                    }
                });
            } else {
                this.error = true;
                if (response.message == "DeviceLocked") this.errorMessage = this.$t("caosTemplate.deviceBusyError");
                else if (response.message == "ConnectionLimitReached") this.errorMessage = this.$t("caosTemplate.agentTimeout");
                else if (response.message == "AgentOffline") this.errorMessage = this.$t("caosTemplate.agentOfflineForInstallation", { task: "create a template" });
                else this.errorMessage = this.$t("caosTemplate.noConfigError");
            }
            this.loadingGetConfigVersion = false;
        },
        async sendRequestCreateTemplate() {
            this.loadingAddTemplate = true;
            let reqData = new AddTemplateReqData(this.newTemplate);
            let response: ApiGenericResponse = await new AddTemplateCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                this.endingMessage = this.$t("caosTemplate.addTemplateSuccess", { name: this.newTemplate.name });
                this.$emit("reload");
            } else {
                this.endingMessage = this.$t("caosTemplate.addTemplateError", { name: this.newTemplate.name });
            }
            this.loadingAddTemplate = false;
        },
        onSelectAllClick() {
            if (this.selectedContent != null && this.availableConfigSections != null && this.selectedContent.length == this.availableConfigSections.length) {
                this.selectedContent = [];
            } else {
                this.selectedContent = this.availableConfigSections.map((c) => c.contentValue);
            }
        },
    },
});
